module.exports = __webpack_public_path__ + "static/media/image-diagram-campaign-donate-sp.ac9380a3.png";